import { extend, configure } from 'vee-validate';
import {
  required,
  digits,
  min,
  max,
  numeric,
  email,
  confirmed,
} from 'vee-validate/dist/rules';
import i18n from '@/plugins/i18n/locale';
import fullWidthHira from './resources/full_width_hira';
import fullWidthKana from './resources/full_width_kana';
import isNotScriptTag from './resources/script';
import isValidPhone from './resources/phone';

configure({
  // this will be used to generate messages.
  defaultMessage: (field, values): string => {
    if (!values) {
      return '';
    }
    values._field_ = i18n.t(`form.fields.${field}`);
    return i18n.t(`validations.messages.${values._rule_}`, values).toString();
  }
});

extend('required', required);
extend('digits', digits);
extend('min', min);
extend('max', max);
extend('numeric', numeric);
extend('email', email);
extend('confirmed', confirmed);
extend('fullWidthHira', fullWidthHira);
extend('fullWidthKana', fullWidthKana);
extend('isNotScriptTag', isNotScriptTag);
extend('isValidPhone', isValidPhone);
